import validationHandlerDirective from './directives/validationHandler';
import scrollToErrorDirective from './directives/scrollToError';
import hasValueDirective from './directives/hasValue';
import selectBoxDirective from './directives/selectbox';
import DatepickerBox from './inputs/DatepickerBox.vue';
import ComboBox from './inputs/ComboBox.vue';
import MobileComboBox from './inputs/MobileComboBox.vue';
import MobileSelectBox from './inputs/MobileSelectBox.vue';
import SelectBox from './inputs/SelectBox.vue';

export default {
  install(Vue) {
    /* Direktivy */
    Vue.directive('select-box', selectBoxDirective);
    Vue.directive('has-value', hasValueDirective);
    Vue.directive('validate', validationHandlerDirective);
    Vue.directive('scroll-to-error', scrollToErrorDirective);
    /* Komponenty */
    Vue.component('datepicker-box', DatepickerBox);
    Vue.component('combo-box', ComboBox);
    Vue.component('mobile-combo-box', MobileComboBox);
    Vue.component('mobile-select-box', MobileSelectBox);
    Vue.component('select-box', SelectBox);
  },
};

export {
  validationHandlerDirective,
  scrollToErrorDirective,
  hasValueDirective,
  selectBoxDirective,
  DatepickerBox,
  ComboBox,
  MobileComboBox,
  MobileSelectBox,
  SelectBox,
};
